import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

const normalizeFactor = (factor) => ({
  id: factor?.Id,
  factor: Number(factor?.Factor || 0),
  min: Number(factor?.Minimo || 0),
  max: Number(factor?.Maximo || 0),
});

export class ConversionFactorService {
  static ENDPOINT = `${BASE}/conversionFactor`;

  static async getAll() {
    const factors = await request({
      url: `${this.ENDPOINT}/`,
      headers: { Accept: 'application/json' },
    });
    if (!Array.isArray(factors)) return factors;
    return factors.map(normalizeFactor);
  }
}

export default ConversionFactorService;
